<template>
	<div id="ag-grid-demo">
		<vx-card class="mb-base">
			<ag-grid-vue
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 mb-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="tableData"
				rowSelection="multiple"
				:enableRangeSelection="true"
				:suppressCopyRowsToClipboard="true"
				colResizeDefault="shift"
				:suppressDragLeaveHidesColumns="true"
				:animateRows="false"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:suppressRowClickSelection="true"
				:rowClassRules="rowClassRules"
				:statusBar="statusBar"
				:sideBar="sideBar"
				:rowHeight="38"
				:getContextMenuItems="getContextMenuItems"
				@column-resized="onColumnResized"
				@filter-changed="filterChanged">
			</ag-grid-vue>
			<div class="vx-row">
				<div class="vx-col w-full">
					<vs-pagination
					:total="totalPages"
					:max="maxPageNumbers"
					v-model="currentPage" />
				</div>
			</div>
		</vx-card>
		
		<action-review-unsuspension-domains v-if="actionReviewType == 'unsuspension' && actionReviewId" :param-id="actionReviewId" :param-percent="actionReviewPercent" @refreshActionReview="populateTableData()"/>
		
		<action-review-suspension-domains v-if="actionReviewType == 'suspension' && actionReviewId" :param-id="actionReviewId" :param-percent="actionReviewPercent" @refreshActionReview="populateTableData()"/>

		<action-review-lock-unlock-domains v-if="(actionReviewType == 'lock' || actionReviewType == 'unlock') && actionReviewId" :param-id="actionReviewId" :param-percent="actionReviewPercent" :param-type="actionReviewType" @refreshActionReview="populateTableData()"/>
	</div>
</template>

<script>
	import { AgGridVue } from "ag-grid-vue"
	import "ag-grid-enterprise";
	import ActionReviewUnsuspensionDomains from '@/components/ag-grid-tables/ActionReviewUnsuspensionDomains.vue'
	import ActionReviewSuspensionDomains from '@/components/ag-grid-tables/ActionReviewSuspensionDomains.vue'
	import ActionReviewLockUnlockDomains from '@/components/ag-grid-tables/ActionReviewLockUnlockDomains.vue'

	import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

	export default {
		components: {
			AgGridVue,
			ActionReviewUnsuspensionDomains,
			ActionReviewSuspensionDomains,
			ActionReviewLockUnlockDomains,
		},
		data() {
			return {
				searchQuery: '',
				gridOptions: {},
				maxPageNumbers: 7,
				gridApi: null,
				defaultColDef: {
					sortable: true,
					resizable: true,
					suppressMenu: true,
					suppressMovable: false,
					filter: false,
					filterParams: {
						suppressAndOrCondition: true,
						newRowsAction: 'keep'
					},
				},
				rowClassRules: null,
				statusBar: null,
				sideBar: null,
				columnDefs: [
				{
					headerName: 'Batch ID',
					field: 'batch_id',
					filter: "agTextColumnFilter",
					minWidth: 150,
					pinned: 'left',
					sort: 'desc',
				},
				{
					headerName: 'Action Type',
					field: 'action_type',
					filter: "agSetColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Note / Reason',
					filter: "agTextColumnFilter",
					minWidth: 275,
					valueGetter: (data) => {
						return data.node.data.reason ? data.node.data.reason : data.node.data.note;
					},
				},
				{
					headerName: 'Progress',
					field: 'progress_rate',
					filter: "agTextColumnFilter",
					minWidth: 150,
					cellRenderer: (data) => {
						if(data.value != null) {
							if(data.value < 100) {
								return `<div class="badge badge--danger inline">${data.value}%</div>`
							}
							else {
								return `<div class="badge badge--success inline">${data.value}%</div>`
							}
						}
						else {
							return ''
						}
					},
				},
				{
					headerName: 'Action Email',
					field: 'user_email',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Rate Reviewed At',
					field: 'rate_reviewed_at',
					filter: 'agMultiColumnFilter',
					filterParams: {
						filters: [
							{
								filter: 'agTextColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									newRowsAction: 'keep',
								}
							},
							{
								filter: 'agDateColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									defaultOption: 'inRange',
									newRowsAction: 'keep',
									comparator: function(filterLocalDateAtMidnight, cellValue) {
										if (cellValue === null) return -1;

										let cellDate = new Date(cellValue);
										
										let cellDateString = new Date(cellDate.toDateString());
										let filterLocalDateAtMidnightString = new Date(filterLocalDateAtMidnight.toDateString());
										
										if (cellDateString.getTime() === filterLocalDateAtMidnightString.getTime()) {
											return 0;
										}
										if (cellDate < filterLocalDateAtMidnight) {
											return -1;
										}
										if (cellDate > filterLocalDateAtMidnight) {
											return 1;
										}
									},
								}
							},
						],
					},
					minWidth: 235,
					cellRenderer: (data) => {
						if(data.value) {
							return this.$moment.utc(data.value).format('DD-MM-YYYY HH:mm:ss')
						}
						else {
							return ''
						}
					},
				},
				{
					headerName: 'Created At',
					field: 'created_at',
					filter: 'agMultiColumnFilter',
					filterParams: {
						filters: [
							{
								filter: 'agTextColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									newRowsAction: 'keep',
								}
							},
							{
								filter: 'agDateColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									defaultOption: 'inRange',
									newRowsAction: 'keep',
									comparator: function(filterLocalDateAtMidnight, cellValue) {
										if (cellValue === null) return -1;

										let cellDate = new Date(cellValue);
										
										let cellDateString = new Date(cellDate.toDateString());
										let filterLocalDateAtMidnightString = new Date(filterLocalDateAtMidnight.toDateString());
										
										if (cellDateString.getTime() === filterLocalDateAtMidnightString.getTime()) {
											return 0;
										}
										if (cellDate < filterLocalDateAtMidnight) {
											return -1;
										}
										if (cellDate > filterLocalDateAtMidnight) {
											return 1;
										}
									},
								}
							},
						],
					},
					minWidth: 235,
					cellRenderer: (data) => {
						if(data.value) {
							return this.$moment.utc(data.value).format('DD-MM-YYYY HH:mm:ss')
						}
						else {
							return ''
						}
					},
				},
				{
					headerName: 'Updated At',
					field: 'updated_at',
					filter: 'agMultiColumnFilter',
					filterParams: {
						filters: [
							{
								filter: 'agTextColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									newRowsAction: 'keep',
								}
							},
							{
								filter: 'agDateColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									defaultOption: 'inRange',
									newRowsAction: 'keep',
									comparator: function(filterLocalDateAtMidnight, cellValue) {
										if (cellValue === null) return -1;

										let cellDate = new Date(cellValue);
										
										let cellDateString = new Date(cellDate.toDateString());
										let filterLocalDateAtMidnightString = new Date(filterLocalDateAtMidnight.toDateString());
										
										if (cellDateString.getTime() === filterLocalDateAtMidnightString.getTime()) {
											return 0;
										}
										if (cellDate < filterLocalDateAtMidnight) {
											return -1;
										}
										if (cellDate > filterLocalDateAtMidnight) {
											return 1;
										}
									},
								}
							},
						],
					},
					minWidth: 235,
					cellRenderer: (data) => {
						if(data.value) {
							return this.$moment.utc(data.value).format('DD-MM-YYYY HH:mm:ss')
						}
						else {
							return ''
						}
					}
				},
				],
				unsuspensionData: null,
				suspensionData: null,
				registryLockData: null,
				actionReviewId: null,
				actionReviewPercent: null,
				actionReviewType: null
			}
		},
		watch: {
			windowWidth(val) {
				// Toggle colummn movable
				this.toggleColumnMovable(val);
				// Toggle colummn pinning
				this.toggleColumnPinned(val);
			},
			tableData(val) {
				if(val) {
					setTimeout(() => {
						if(this.gridApi.getDisplayedRowCount() == 0) {
							this.gridApi.showNoRowsOverlay();
						}
						else {
							this.gridApi.hideOverlay();
						}
					}, 50);
				}
			},
		},
		computed: {
			windowWidth: function() {
				return this.$store.state.windowWidth;
			},
			tableData: function() {
				if(this.unsuspensionData != null && this.suspensionData != null && this.registryLockData != null) {
					return [ ...this.unsuspensionData, ...this.suspensionData, ...this.registryLockData ];
				}
				else if(this.unsuspensionData != null && this.suspensionData != null) {
					return [ ...this.unsuspensionData, ...this.suspensionData ];
				}
				else if(this.suspensionData != null && this.registryLockData != null) {
					return [ ...this.suspensionData, ...this.registryLockData ];
				}
				else if(this.unsuspensionData != null && this.registryLockData != null) {
					return [ ...this.unsuspensionData, ...this.registryLockData ];
				}
				else if(this.unsuspensionData != null) {
					return this.unsuspensionData;
				}
				else if(this.suspensionData != null) {
					return this.suspensionData;
				}
				else if(this.registryLockData != null) {
					return this.registryLockData;
				}
				else {
					return [];
				}
			},
			paginationPageSize() {
				if(this.gridApi) {
					return this.gridApi.paginationGetPageSize()
				}
				else {
					return 500
				}
			},
			totalPages() {
				if(this.gridApi) {
					return this.gridApi.paginationGetTotalPages()
				}
				else {
					return 0
				}
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
						else return 1
					},
				set(val) {
					this.gridApi.paginationGoToPage(val - 1);
				}
			},
		},
		methods: {
			toggleColumnMovable(val) {
				if(val <= 576) {
					this.defaultColDef['suppressMovable'] = true;
				}
				else {
					this.defaultColDef['suppressMovable'] = false;
				}
			},
			toggleColumnPinned(val) {
				if(val <= 576) {
					this.maxPageNumbers = 4;
					this.gridOptions.columnApi.setColumnPinned('domain', null);
				}
				else {
					this.gridOptions.columnApi.setColumnPinned('domain', 'left')
				}
			},
			onColumnResized() {
				this.gridApi.resetRowHeights();
			},
			updateSearchQuery(val) {
				this.gridApi.setQuickFilter(val);
			},
			sizeColumnsToFit() {
				this.gridApi.sizeColumnsToFit();
			},
			filterCompleted() {
				// Get a reference to the progress filter instance
				let progressFilterInstance = this.gridApi.getFilterInstance('progress_rate');

				// Set the model for the filter
				progressFilterInstance.setModel({
					type: 'notEqual',
					filter: '100'
				});

				// Get grid to run filter operation again
				this.gridApi.onFilterChanged();
			},
			filterChanged() {
				if(this.gridApi.getDisplayedRowCount() == 0) {
					this.gridApi.showNoRowsOverlay();
				}
				else {
					this.gridApi.hideOverlay();
				}
			},
			populateTableData() {
				let self = this;

				// Get Unsuspension Data
				this.$axiosSecure.get('/unsuspension-action-review-json')
				.then((response) => {
					this.unsuspensionData = response.data.map(x=> ({ ...x, action_type: 'unsuspension' }));
				})
				.catch((error) => {
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});

				// Get Suspension Data
				this.$axiosSecure.get('/suspension-action-review-json')
				.then((response) => {
					this.suspensionData = response.data.map(x=> ({ ...x, action_type: 'suspension' }));
				})
				.catch((error) => {
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});

				// Get Lock Unlock Data
				this.$axiosSecure.get('/lock-unlock-action-review-json')
				.then((response) => {
					this.registryLockData = response.data.map(x=> ({ ...x, action_type: x['action'] }));
				})
				.catch((error) => {
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});
			},
			getContextMenuItems(params) {
				return [
					{
						name: "View Domains",
						action: () => {
							this.actionReviewId = params['node']['data']['batch_id'];
							this.actionReviewPercent = params['node']['data']['progress_rate'];
							this.actionReviewType = params['node']['data']['action_type'];
						},
					},
					'separator',
					'copy',
					'copyWithHeaders',
					'paste',
					'separator',
					'export',
				];
			}
		},
		beforeMount() {
			// Table Data AXIOS Call
			this.populateTableData();

			// Reset movable columns on mobile
			this.toggleColumnMovable(this.windowWidth);

			// Set Grid sidebar
			this.sideBar = {
				toolPanels: [
				{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel",
					toolPanelParams: {
						suppressRowGroups: true,
						suppressValues: true,
						suppressPivots: true,
						suppressPivotMode: true,
						suppressSideButtons: true,
						suppressColumnSelectAll: true,
						suppressColumnExpandAll: true
					}
				}
				],
			};
		},
		mounted() {
			this.gridApi = this.gridOptions.api;

			// Resize to fit columns
			this.sizeColumnsToFit();

			// Reset pinned columns on mobile
			this.toggleColumnPinned(this.windowWidth);
			
			// Auto filter out completed
			this.filterCompleted();

			// Page Refresh Event
			this.$root.$on('refreshPage', () => {
				// Reset filters
				this.gridApi.setFilterModel(null);
				// Reset selection
				this.gridApi.deselectAll();
				// Reset sort
				this.gridApi.setSortModel([
					{
					colId: "batch_id",
					sort: "desc"
					}
				]);
				// Table Data AXIOS Call
				this.populateTableData();
			});

			// Page Download Event
			this.$root.$on('downloadPage', () => {
				// AgGrid CSV Export
				this.gridApi.exportDataAsCsv()
			});

		},
		destroyed() {
			// Unbind Button Event Listeners
			this.$root.$off('refreshPage');
			this.$root.$off('downloadPage');
		}
	}

</script>